import React, {Component} from 'react'
import { connect } from 'react-redux'

// Actions
import { getPunchClockInformation, savePunchClockInformation } from '../../../actions/settings'

// Components
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import Radio from '../../../shared/elements/radio'

// Utils
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'
import LabelWrapper from '../../../shared/elements/labelWrapper'

class PunchClock extends Component {

  constructor (props) {
    super(props)
    this.state = {
      PunchClock: {
        ShopId: 0,
        Active: false,
        // ManuelPunchIn: false,
        PunchInVia: 0,
        IpRestriction: ''
      }
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getPunchClockInformation()
  }

  getPunchClockInformation () {
    this.props.getPunchClockInformation(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        PunchClock: {
          ShopId: res.data.ShopId,
          Active: res.data.Active,
          // ManuelPunchIn: res.data.ManuelPunchIn,
          PunchInVia: res.data.PunchInVia,
          IpRestriction: res.data.IpRestriction
        }})
    }, (err) => {
      console.log(err)
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    if (e.target.name === 'PunchInVia') {
      value = parseInt(e.target.value)
    }
    this.setState({
      PunchClock: {
        ...this.state.PunchClock,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'checkbox' || e.target.name === 'PunchInVia') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    this.props.savePunchClockInformation(this.state.PunchClock).then(() => {
      // Toastr (replace dict. key)
      // window.toastr.success(translation('1720'), translation('13424'))
    }, () => {
      // Toastr (replace dict. key)
      window.toastr.error(translation('1721'), translation('216'))
    })
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    let { PunchClock } = this.state
    return (
      <Row>
        <Col>
          <Panel title={translation('437')}>
            <Switch name='Active' onChange={this.onChange} checked={PunchClock.Active} labelText={translation('295')} />
            {/* <Switch name='ManuelPunchIn' onChange={this.onChange} checked={PunchClock.ManuelPunchIn} labelText={translation('1495')} helpText={translation('1986')} /> */}
            {PunchClock.Active && [
              <LabelWrapper key='PunchInVia' labelText={translation('16676')} helpText={translation('1986')}>
                <Radio name='PunchInVia' value='0' onChange={this.onChange} checked={PunchClock.PunchInVia === 0} labelText={translation('16677')} />
                <Radio name='PunchInVia' value='1' onChange={this.onChange} checked={PunchClock.PunchInVia === 1} labelText={translation('16678')} />
                <Radio name='PunchInVia' value='2' onChange={this.onChange} checked={PunchClock.PunchInVia === 2} labelText={translation('16679')} />
              </LabelWrapper>,
              <Text key='IpRestriction' name='IpRestriction' value={PunchClock.IpRestriction || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('553')} helpText={translation('1987')} />
            ]}
          </Panel>
        </Col>
      </Row>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPunchClockInformation,
  savePunchClockInformation
})(PunchClock)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/PunchClock/index.js